/**
 * Privacy copy.
 *
 * PRIVACY_VERSION must match Onboarding::PRIVACY_VERSION in PHP — consents are
 * stored per version, so changing the text means a new version and a new ask
 * from everybody.
 *
 * TODO (Željko): the full policy below is a draft with the right sections and
 * the app's actual behaviour filled in. The legal wording — controller name
 * and address, legal basis, retention periods as you want them stated, the
 * supervisory authority — is yours to finalise. When you replace it, bump
 * PRIVACY_VERSION here and in lib/Onboarding.php together.
 */

export const PRIVACY_VERSION = 'v2-draft'

export const PRIVACY_SUMMARY = [
  'We keep your name, email, photo and whatever you write into the app yourself.',
  'The journal and the capsule are private. No admin screen reads them.',
  'No third-party analytics. No Google Analytics, no pixels.',
  'You can download your data, or ask for it to be deleted, at any time.',
]

export const PRIVACY_DOCUMENT = {
  title: 'Privacy',
  updated: 'Draft — the final text arrives before the first retreat.',
  sections: [
    {
      heading: 'Who processes the data',
      body: [
        'Differ LX (controller — full legal name, address and registration number come in the final version).',
        'For anything about your data: retreat@differlx.com.',
      ],
    },
    {
      heading: 'What we collect',
      body: [
        'Your name and email — so we can recognise you and send you the retreat.',
        'The photo and description you set yourself — seen only by your group, and only once profiles unlock.',
        'Questionnaire answers — used for your result and nothing else.',
        'Your journal and capsule — the text and recordings you write or record yourself.',
        'Technical data about the device for notifications (the push endpoint) and a record of whether a notification was delivered.',
        'Retreat photographs uploaded by the organiser.',
      ],
    },
    {
      heading: 'What there is none of',
      body: [
        'No third-party analytics — no Google Analytics, no Facebook pixel, no tracking of any kind.',
        'No sale or sharing of data with third parties for marketing.',
        'Videos in briefs come from youtube-nocookie.com, Vimeo with do-not-track on, or our own video host. None of them sets a cookie or reports anything until you press play.',
      ],
    },
    {
      heading: 'The journal and the capsule',
      body: [
        'This is the most important part of this page: your journal and your capsule are private.',
        'There is no admin screen in the app that can read them — not because it is hidden, but because no such endpoint was ever written.',
        'The capsule does not open before the date you set, not even for you.',
      ],
    },
    {
      heading: 'Cookies',
      body: [
        'We use one cookie — a session cookie, so you stay signed in. It is not for tracking and is shared with nobody.',
      ],
    },
    {
      heading: 'How long we keep it',
      body: [
        'Retreat data is kept for the programme and a period after it (currently set to 24 months from the end).',
        'After that, personal data is anonymised: the name is replaced, email and photo are deleted, and the journal, capsule and answers are deleted entirely.',
        'The programme content and the shared gallery remain.',
      ],
    },
    {
      heading: 'Your rights',
      body: [
        'Download — on the You screen you can take all of your data as a JSON file at any time.',
        'Deletion — write to retreat@differlx.com and the account is deleted in full, together with photographs and recordings.',
        'Correction — you change your name, description and photo yourself in the app.',
        'Withdrawing consent — you can turn notifications off on the You screen at any time.',
        'Complaint to the supervisory authority — the Croatian Personal Data Protection Agency (AZOP), Zagreb.',
      ],
    },
    {
      heading: 'Where the data lives',
      body: [
        'On a server in the European Union. The database and uploaded files are not reachable from the web — every photograph passes a sign-in check.',
        "Notifications go through your browser's push service (Google, Apple or Mozilla), which receives only the encrypted body of the message.",
        'Email goes through Brevo (Sendinblue), with servers in the EU.',
      ],
    },
  ],
}
